export const COURSE__PERMISSIONS = {
  COURSES_AND_TEMPLATES: {
    VIEW: {
      permissionGroupName: 'Przeglądanie kursów i szablonów',
      NONE: {
        dbName: 'COURSE__COURSES_AND_TEMPLATES__VIEW__NONE',
        name: 'Brak uprawnień',
        description: 'Brak dostępu do kursów i szablonów.'
      },
      OWNED: {
        dbName: 'COURSE__COURSES_AND_TEMPLATES__VIEW__OWNED',
        name: 'Własne kursy i szablony',
        description: 'Możliwość przeglądania własnych kursów.'
      },
      RELATED_TO_GOALS: {
        dbName: 'COURSE__COURSES_AND_TEMPLATES__VIEW__RELATED_TO_GOALS',
        name: 'Kursy i szablony powiązane z celami użytkownika',
        description: 'Możliwość przeglądania kursów i szablonów powiązanych z celami użytkownika.'
      },
      ALL: {
        dbName: 'COURSE__COURSES_AND_TEMPLATES__VIEW__ALL',
        name: 'Wszystkie kursy i szablony',
        description: 'Możliwość przeglądania wszystkich dostępnych kursów i szablonów.'
      }
    },
    MANAGE: {
      permissionGroupName: 'Zarządzanie kursami i szablonami',
      NONE: {
        dbName: 'COURSE__COURSES_AND_TEMPLATES__MANAGE__NONE',
        name: 'Brak uprawnień',
        description: 'Brak możliwości zarządzania kursami i szablonami.'
      },
      OWNED: {
        dbName: 'COURSE__COURSES_AND_TEMPLATES__MANAGE__OWNED',
        name: 'Własne kursy ',
        description:
          'Możliwość zarządzania własnymi kursami : dodawanie/edycja/archiwizacja kursów, dodawanie/usuwanie uczniów w kursie'
      },
      RELATED_TO_GOALS: {
        dbName: 'COURSE__COURSES_AND_TEMPLATES__MANAGE__RELATED_TO_GOALS',
        name: 'Kursy i szablony powiązane z celami użytkownika',
        description:
          'Możliwość zarządzania kursami i szablonami powiązanymi z celami użytkownika: dodawanie/edycja/archiwizacja kursów, edycja szablonów, dodawanie/usuwanie uczniów w kursie, dodawanie/usuwanie nauczycieli w kursie'
      },
      ALL: {
        dbName: 'COURSE__COURSES_AND_TEMPLATES__MANAGE__ALL',
        name: 'Wszystkie kursy i szablony',
        description:
          'Możliwość zarządzania wszystkimi kursami i szablonami: dodawanie/edycja/archiwizacja kursów, edycja szablonów, dodawanie/usuwanie uczniów w kursie, dodawanie/usuwanie nauczycieli w kursie'
      }
    }
  },
  COURSES_IN_COURSES: {
    PUBLISH_PRIVATE_COURSE_AS_TEMPLATE: {
      permissionGroupName: 'Publikowanie kursów jako szablonów',
      NONE: {
        dbName: 'COURSE__COURSES_IN_COURSES__PUBLISH_PRIVATE_COURSE_AS_TEMPLATE__NONE',
        name: 'Brak uprawnień',
        description: 'Brak możliwości publikowania kursów jako szablonów.'
      },
      ENABLED: {
        dbName: 'COURSE__COURSES_IN_COURSES__PUBLISH_PRIVATE_COURSE_AS_TEMPLATE__ENABLED',
        name: 'Możliwość publikowania kursów jako szablonów',
        description:
          'Możliwość publikowania kursów jako szablonów dostępnych do ponownego wykorzystania i widocznych dla innych użytkowników w bazie kursów.'
      }
    }
  }
} as const
